export default __webpack_public_path__ + "no-action-placeholder.svg";